import { GraphQLWsLink } from "@apollo/client/link/subscriptions";
import { createClient } from "graphql-ws";
import { getWebsocketGraphqlPath } from "../services/getWebsocketGraphqlPath";

export const websocketLink = new GraphQLWsLink(
  createClient({
    url: getWebsocketGraphqlPath(),
  }),
);
